import React from "react";
import { Route, Redirect } from "react-router-dom";

const RecruitmentGuard = ({ children, ...rest }) => {
    const token = localStorage.getItem("kloka:token:data");
    const type = localStorage.getItem("kloka:type");
    const categories = localStorage.getItem("kloka:categories");
    
    const isValid = categories
        ? categories && categories.includes("RECRUITMENT")
        : false;

    return (
        <Route
            {...rest}
            render={({ location }) =>
                (token && (type === "inhouse") && isValid) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                        pathname: "/",
                        state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};

export default RecruitmentGuard;
